import React, {Component} from 'react';

export default class Slide extends Component{
	render(){	
		return(
			<div className="App-header">	 
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/Components/Globals/Slide/slide.jsx